import { Injectable, OnDestroy } from '@angular/core';
import { Company, ICompany, IdentityWebApiClient, ListCompaniesRequest } from 'identity-webapi-client';
import { ReplaySubject, Subscription } from 'rxjs';
import { Role } from '../shared/models/role.model';
import { AuthService } from './auth.service';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {

  public companies$ = new ReplaySubject<ICompany[]>(1);

  constructor(
    private identityWebApiClient: IdentityWebApiClient,
    private authService: AuthService) {
    this.authService.userSubject.subscribe(() => {
      if (this.authService.hasAnyRole([Role.SituSystemsDeveloper, Role.SituSystemsAdmin, Role.SituSystemsEmployee])) {
        this.getCompanies();
      }
      else{
        this.companies$.next(this.authService.listCompanies());
      }
    });
  }

  getCompanies() {
    const req = { pageNumber: 1, pageSize: 1000 } as ListCompaniesRequest;

    return this.identityWebApiClient.listCompanies(req).then(response => {
      let sorted = response?.items?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? ""));
      this.companies$.next(sorted);
    }).catch(err => {
      console.error('Failed to load companies, retrying in 3s...', err);
      return new Promise<void>(resolve => setTimeout(resolve, 3000)).then(() => {
        return this.identityWebApiClient.listCompanies(req).then(response => {
          let sorted = response?.items?.sort((a, b) => (a?.name ?? "").localeCompare(b?.name ?? ""));
          this.companies$.next(sorted);
        });
      }).catch(retryErr => {
        console.error('Retry failed, emitting empty companies list', retryErr);
        this.companies$.next([]);
      });
    });
  }

  getCompanyByCode(code: string) {
    if (!code) {
      return Promise.resolve(undefined);
    }

    let company = this.authService.listCompanies().find(x => x.code?.toLowerCase() == code);
    if (company) {
      return Promise.resolve(company);
    }

    if (this.authService.hasFullAccess()) {
      return new Promise<Company | undefined>((resolve, reject) => {
        this.companies$.subscribe({
          next: companies => {
            return resolve(companies.find(x => x.code?.toLowerCase() == code) as Company ?? undefined);
          },
          error: err => {
            reject(err);
          }
        });
      });
    }

    return Promise.resolve(undefined);
  }
  
  getCompanyById(id: string) {
    if (!id) {
      return Promise.resolve(undefined);
    }

    let company = this.authService.listCompanies().find(x => x.id?.toLowerCase() == id);
    if (company) {id
      return Promise.resolve(company);
    }

    if (this.authService.hasFullAccess()) {
      return new Promise<Company | undefined>((resolve, reject) => {
        this.companies$.subscribe({
          next: companies => {
            return resolve(companies.find(x => x.id?.toLowerCase() == id) as Company ?? undefined);
          },
          error: err => {
            reject(err);
          }
        });
      });
    }

    return Promise.resolve(undefined);
  }
}
